import React from 'react';

// Импортируйте ваши SVG-файлы
import { ReactComponent as ProfileIcon } from '../icons/profile.svg';
import { ReactComponent as TeamIcon } from '../icons/team.svg';
import { ReactComponent as HomeIcon } from '../icons/home.svg';
import { ReactComponent as LogoutIcon } from '../icons/logout.svg';
import { ReactComponent as ChannelsIcon } from '../icons/channels.svg';
import { ReactComponent as CategoriesIcon } from '../icons/categories.svg';
import { ReactComponent as TvscheduleIcon } from '../icons/tvschedule.svg';
import { ReactComponent as SourceIcon } from '../icons/source.svg';
import { ReactComponent as RemoveIcon } from '../icons/remove.svg';
import { ReactComponent as EditIcon } from '../icons/edit.svg';
import { ReactComponent as SecureIcon } from '../icons/secure.svg';
import { ReactComponent as ProductsIcon } from '../icons/products.svg';
import { ReactComponent as PresentationsIcon } from '../icons/presentations.svg';
import { ReactComponent as ScenariosIcon } from '../icons/scenarios.svg';
import { ReactComponent as VideoIcon } from '../icons/video.svg';
import { ReactComponent as AudioIcon } from '../icons/audio.svg';
import { ReactComponent as DocumentsIcon } from '../icons/documents.svg';
import { ReactComponent as StatIcon } from '../icons/stat.svg';
import { ReactComponent as DownloadIcon } from '../icons/download.svg';
import { ReactComponent as UploadIcon } from '../icons/upload.svg';
import { ReactComponent as GenerateIcon } from '../icons/generate.svg';

// Карта иконок
const icons = {
    profile: ProfileIcon,
    team: TeamIcon,
    home: HomeIcon,
    logout: LogoutIcon,
    channels: ChannelsIcon,
    categories: CategoriesIcon,
    tvschedule: TvscheduleIcon,
    source: SourceIcon,
    remove: RemoveIcon,
    edit: EditIcon,
    secure: SecureIcon,
    products: ProductsIcon,
    presentations: PresentationsIcon,
    scenarios: ScenariosIcon,
    video: VideoIcon,
    audio: AudioIcon,
    documents: DocumentsIcon,
    stat: StatIcon,
    download: DownloadIcon,
    upload: UploadIcon,
    generate: GenerateIcon,
};

interface IconProps {
    name: keyof typeof icons;
    size?: number;
    color?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 22}) => {
    const SvgIcon = icons[name];

    return <SvgIcon width={size} height={size} />;
};

export default Icon;
